<template>
    <div class="form_root">
      <div class="text-left">
        <h3>
          <router-link to="/clientes/cob">Cobrança</router-link> » {{crud_action}} 
          <button @click.prevent="saveForm()" class="btn btn-success pull-right">Salvar</button>
          <span class="pull-right" v-if="crud_action==='Alterando'">
            <router-link :to="'/historico/'+form.cod"><i class="glyphicon glyphicon-list" title="Histórico"></i></router-link>
            <router-link :to="'/agenda/c/'+form.cod"><i class="glyphicon glyphicon-book" title="Agenda"> </i></router-link>
            <router-link :to="'/tarefa/c/'+form.cod"><i class="glyphicon glyphicon-flag" title="Tarefas"> </i></router-link>&nbsp;
          </span>
        </h3>
        <hr>
      </div>
        <div class="form-group col-sm-3">
            <label class="control-label">Cód.</label>
            <input type="text" v-model="form.cod" placeholder="cod" class="form-control"/>
        </div>
        <div class="form-group col-sm-2">
            <label class="control-label">Chave Cliente</label>
            <input type="text" v-model="form.chavecliente" placeholder="Chave CLIENTE pos.16" class="form-control"/>
        </div>
        <div class="form-group col-sm-3">
          <label class="control-label">Grupo</label>
          <input type="text" v-model="form.grupo" class="form-control up" placeholder="Grupo / Chave cliente"/>
        </div>
        <div class="form-group col-sm-3">
            <label class="control-label">Situação</label>
            <select v-model="form.situacao" class="form-control">    
              <option value="4">Ativo</option>
              <option value="3">Ativo - PS Antigo</option>
              <option value="2">Bloqueado - Não Paga!</option>
              <option value="1">Excluído - Mudou Razão</option>
              <option value="0">Excluído</option>
            </select>
        </div>
        <div class="form-group col-sm-6">
            <label for="ipt_cod" class="control-label">Razão Social</label>
            <input type="text" v-model="form.razao" class="form-control up" placeholder="razao"/>
        </div>
        <div class="form-group col-sm-3">
            <label for="ipt_cod" class="control-label">CNPJ</label>
            <input type="text" v-model="form.cnpj" @keydown="maskCnpjInput($event)" @keyup="maskCnpjInput($event)" @change="maskCnpjInput($event)" class="form-control" placeholder="xx.xxx.xxx/xxxx.xx" maxlength="18"/>
        </div>
        <div class="form-group col-sm-2">
            <label for="ipt_cod" class="control-label">Insc. Estadual</label>
            <input type="text" v-model="form.ie" @keydown="maskIeInput($event)" @keyup="maskIeInput($event)" class="form-control" placeholder="xxx/xxxxxxx" maxlength="11"/>
        </div>
        <div class="form-group col-sm-5">
            <label for="ipt_cod" class="control-label">Fantasia</label>
            <input type="text" v-model="form.fantasia" class="form-control up" placeholder="Fantasia"/>
        </div>
        <div class="form-group col-sm-2">
            <label for="ipt_cod" class="control-label">Vcto.</label>
            <input type="text" v-model="form.cobdia" class="form-control" placeholder="Dia"/>
        </div>
        <div class="form-group col-sm-2">
            <label for="ipt_cod" class="control-label">Valor</label>
            <input type="text" v-model="form.cobvalor" @focusout="maskMonetarioInput($event)" class="form-control" placeholder="R$ Use PONTO"/>
        </div>
        <div class="form-group col-sm-3">
          <input type="checkbox" v-model="form.recebenfse"/><label class="control-label">NFSe</label><br>
          <input type="checkbox" v-model="form.emailnfse"/><label class="control-label">NFSe por email</label><br>
          <input type="checkbox" v-model="form.emailboleto"/><label class="control-label">Boleto por email</label>
        </div>

        <endereco prefix="cob" :ender="form.cob" title="de Cobrança"></endereco>

        <endereco prefix="end" :ender="form.end" title="da Empresa"></endereco>

        <telefones :telefones="form.telefone" @add="addItem" @remove="removeItem"></telefones>

        <emails :emails="form.email" @add="addItem" @remove="removeItem"></emails>

        <acessos :acessos="form.acesso" @add="addItem" @remove="removeItem"></acessos>

        <div class="form-group col-sm-12">
            <label for="psweb" class="control-label">Endereço PSWeb Externo</label>
            <input type="text" v-model="form.psweblink" class="form-control" placeholder="ex: http://ps2000.ddns.com.br:8081/psweb/"/>
        </div>

        <div class="form-group col-sm-12">
          <div class="colsm-12">
            <label for="">Uso do Sistema</label>
          </div>
            <div class="form-group col-sm-2">
              <label class="control-label">Sistema Operacional</label>
              <select v-model="form.uso" name="so" id="" placeholder="" class="form-control">
                <option value="windows" :selected="form.unfe==='windows'">Windows</option>
                <option value="linux" :selected="form.unfe==='linux'">Linux</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">NFe</label>
              <select v-model="form.unfe" name="nfe" id="" placeholder="NFe" class="form-control">
                <option value="0" :selected="form.unfe==='0'">Não usa</option>
                <option value="nfe+" :selected="form.unfe==='nfe+'">NFE - PsWeb SOAP</option>
                <option value="nfe" :selected="form.unfe==='nfe'">NFE - PsWeb</option>
                <option value="-nfe" :selected="form.unfe==='-nfe'">NFE - Ps2000</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">Cupom Fiscal</label>
              <select v-model="form.ucfe" name="cfe" id="" class="form-control">
                <option value="0" :selected="form.ucfe==='0'">Não usa</option>
                <option value="cfe+" :selected="form.ucfe==='cfe+'">NFCe - PsWeb Windows</option>
                <option value="cfe" :selected="form.ucfe==='cfe'">NFCe - PsWeb Acbr</option>
                <option value="cf" :selected="form.ucfe==='cf'">CF - PsWeb</option>
                <option value="-cf" :selected="form.ucfe==='-cf'">CF - Ps2000</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">Nota de Serviço</label>
              <select v-model="form.unfse" name="nfse" id="" class="form-control">
                <option value="0" :selected="form.unfse==='0'">Não usa</option>
                <option value="nfse" :selected="form.unfse==='nfse'">NFSe - PsWeb</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">MDFe</label>
              <select v-model="form.umdfe" name="mdfe" id="" class="form-control">
                <option value="0" :selected="form.umdfe==='0'">Não usa</option>
                <option value="mdfe" :selected="form.umdfe==='mdfe'">MDFe - PsWeb</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">CTe</label>
              <select v-model="form.ucte"  name="cte" id="" class="form-control">
                <option value="0" :selected="form.ucte==='0'">Não usa</option>
                <option value="cte" :selected="form.ucte==='cte'">CTe - PsWeb</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">Certificado</label>
              <select v-model="form.certificado" name="certificado" id="" class="form-control">
                <option value="A1" :selected="form.certificado==='A1'">A1 - Arquivo</option>
                <option value="A2" :selected="form.certificado==='A2'">A2 - Token</option>
                <option value="A3" :selected="form.certificado==='A3'">A3 - Cartão</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">Etiqueta</label>
              <select v-model="form.uetiq" name="etiq" id="" class="form-control">
                <option value="0" :selected="form.uetiq==='0'">Não usa</option>
                <option value="etiq" :selected="form.uetiq==='etiq'">PsWeb</option>
                <option value="-etiq" :selected="form.uetiq==='-etiq'">Ps2000</option>
              </select>
            </div>
            <div class="form-group col-sm-2">
              <label class="control-label">Remessa</label>
              <select v-model="form.uremessa" name="remessa" id="" class="form-control">
                <option value="0" :selected="form.uremessa==='0'">Não usa</option>
                <option value="remessa" :selected="form.uremessa==='remessa'">PsWeb</option>
                <option value="-remessa" :selected="form.uremessa==='-remessa'">Ps2000</option>
              </select>
            </div>
        </div>
        <div class="text-left col-sm-12">
          <hr>
          <h3>
            <router-link to="/clientes/cob">Cobrança</router-link> » {{crud_action}}
            <button @click.prevent="saveForm()" class="btn btn-success pull-right">Salvar</button>
            <button @click="remove()" v-if="form.cod" class="btn btn-danger pull-right">Excluir</button>
          </h3>
          <br><br><br>
        </div>
    </div>
</template>

<script>
  import Mask from './Mask.js'
  import endereco from './CliFormEndereco.vue'
  import telefones from './CliFormTelefone'
  import emails from './CliFormEmail.vue'
  import acessos from './CliFormAcesso.vue'
  import swal from 'sweetalert'

  export default {
    name: 'form',
    components: { endereco, telefones, emails, acessos },
    data () {
      return {
        crud_action: '',
        form: {
          cod: 0,
          chavecliente: '',
          grupo: '',
          situacao: '4',
          razao: '',
          fantasia: '',
          cnpj: '',
          ie: '',
          cobdia: 1,
          cobvalor: 'R$ 0,00',
          recebenfse: false,
          emailnfse: false,
          emailboleto: false,
          cob: {},
          end: {},
          telefone: [],
          email: [],
          acesso: [],
          uso: 'windows',
          certificado: 'A1',
          unfe: '0',
          ucfe: '0',
          unfse: '0',
          umdfe: '0',
          ucte: '0',
          uetiq: '0',
          uremessa: '0',
          psweblink: '',
          excluido: false
        }
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getcliente.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            // console.log(response)
            this.fetchData(response.body)
          },
          function (error) {
            console.log(error)
          }
        )
      },
      save (form) {
        const url = './api/php/addcliente.php'
        this.$http.post(url, JSON.stringify(form)).then(
          function (response) {
            console.log(response.body)
            if (form.cod === 0) {
              swal('Sucesso', form.razao + ' adicionado a lista de clientes', 'success')
            } else {
              swal('Sucesso', form.razao + ' alterado com sucesso', 'success')
            }
            this.closeForm()
          },
          function (error) {
            console.log(error)
          }
        )
      },
      remove () {
        const cod = this.form.cod
        const url = './api/php/removecliente.php'
        this.$http.post(url, JSON.stringify({'cod': cod})).then(
          function (response) {
            console.log(response)
            swal('Excluído com sucesso', this.form.razao + ' foi excluído.', 'success')
          },
          function (error) {
            console.log(error)
          }
        )
      },
      fetchData (o) {
        this.form = o
        this.form.cnpj = Mask.cnpj(o.cnpj)
        this.form.ie = Mask.ie(o.ie)
        this.form.cobvalor = Mask.monetario(o.cobvalor, true)
        this.form.cob = { 'rua': o.cobrua, 'numero': o.cobnumero, 'compl': o.cobcompl, 'cep': o.cobcep, 'bairro': o.cobbairro, 'cidade': o.cobcidade, 'uf': o.cobuf, 'referencia': o.cobreferencia }
        this.form.end = { 'rua': o.endrua, 'numero': o.endnumero, 'compl': o.endcompl, 'cep': o.endcep, 'bairro': o.endbairro, 'cidade': o.endcidade, 'uf': o.enduf, 'referencia': o.endreferencia }
      },
      saveForm () {
        let p = ''
        for (p in this.form.cob) { this.form['cob' + p] = this.form.cob[p] } delete this.form.cob
        for (p in this.form.end) { this.form['end' + p] = this.form.end[p] } delete this.form.end
        this.save(this.form)
      },
      addItem (item, listname, index) {
        if (index === -1) {
          this.form[listname].push(item)
        } else {
          this.form[listname][index] = item
        }
      },
      removeItem (listname, index) {
        this.form[listname].splice(index, 1)
      },
      closeForm () {
        this.$router.go(-1)
      },
      maskCnpjInput (e) {
        e.target.value = Mask.cnpj(e.target.value)
      },
      maskIeInput (e) {
        e.target.value = Mask.ie(e.target.value)
      },
      maskMonetarioInput (e) {
        e.target.value = Mask.monetario(e.target.value)
      }
    },
    created () {
      const grupo = this.$route.params.grupo
      const cod = parseInt(this.$route.params.id)
      if (grupo !== undefined && cod === 0) {
        this.crud_action = 'Nova Filial'
        this.form.grupo = grupo
      } else if (cod > 0) {
        this.crud_action = 'Alterando'
        this.load({'cod': cod})
      } else {
        this.crud_action = 'Novo'
      }
    }
  }
</script>

<style scoped>
    .form_root {
      text-align: left;
      margin-left: 10vw;
      width: 80vw;
    }
    .form_root label {
      color: #444;
    }
    .form_root >>> .form-control {
      padding: 5px;
    }
    .form_root >>> .glyphicon-remove {
      color: #c00;
    }
    .form_root >>> .root ul li {
        background: #e1e1e1;
        margin: 10px;
        padding: 10px;
    }
    .form_root >>> .form {
        background: #ccc;
        padding: 15px 0 15px 0;
    }
    input[type="checkbox"] {
      margin-right: 10px;
    }
    .up {
      text-transform: uppercase;
    }
    .btn-danger {
      margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/CliForm.vue